export class StudentField {
    TabId: number;
    TabTitle: string;
    TabSequence: Number;
    DataFieldId: Number;
    ObjectType: Number;
    FieldName: string;
    SystemField: boolean;
    DisplaySize: Number;
    FieldSize: Number;
    ColumnData: string;
    ExternalDataId: number;
    DataFieldFormatType: number;
    DataTypeFormat: number;
    IsExternal: boolean;
    ColumnPosition: number;
    Row: number;
    NumberColumnUsed: number;
    Alignment: number;
    Visible: boolean;
    Editable: boolean;
    Error: string;
    MinimumFieldValue: number;
    TabMenus = [];
    OldColumnData: string;
    OldExternalDataId: number;
    SelectedTabId: number;
    isEdited: boolean;
    FieldOptions = [];
    OptionSelected: number;
    StudentId: number;
    ErrorCollection = [];
    ValidateIdLengthOnly: boolean;
    ErrorCount: any;
    FieldWidth: number;
}

export class TabMenu {
    TabId: number;
    TabTitle: string;
    TabSequence: number;
    MaxRow: number;
}
export class StudentFieldLookup {
    Id: number;
    Code: string;
    CodeDescription: string;
    Sequence: number;
    DataFieldId: number;
}
export class StudentFieldsLookup {
    Id: string;
    Code: string;
    CodeDescription: string;
    Default: boolean;
    Sequence: number;
    DataFieldId: number;
}